import { GitForkIcon, PlusIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Flex } from '@/components/ui/flex'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './keyless-access.styled'
import { KeylessNotConnectedProps } from './keyless-access.types'

export const KeylessNotConnected = ({
  label,
  onCreateNew,
  onConnectExisting,
  isCreating = false,
  isConnecting = false,
  isConnectDisabled = false,
  isConnectHidden = false,
}: KeylessNotConnectedProps) => {
  const { t } = useTranslation(['clients'])

  return (
    <S.FieldRow>
      <Flex gap={6} align="center">
        <Typography size="text-medium" color="primary500" as="span" whiteSpace="nowrap">
          {label}
        </Typography>
      </Flex>
      <Flex gap={24} justify="flex-end" align="center">
        <S.NotConnectedButtonWrapper>
          <Button size="small" loading={isCreating} onClick={onCreateNew}>
            {t('clients:keylessAccess.notConnected.createNewUser')}
            <Icon icon={PlusIcon} size="1.6rem" />
          </Button>
        </S.NotConnectedButtonWrapper>
        {!isConnectHidden && (
          <S.NotConnectedButtonWrapper>
            <Button
              size="small"
              loading={isConnecting}
              disabled={isConnectDisabled}
              onClick={onConnectExisting}
            >
              {t('clients:keylessAccess.notConnected.connectExisting')}
              <Icon icon={GitForkIcon} size="1.6rem" />
            </Button>
          </S.NotConnectedButtonWrapper>
        )}
      </Flex>
    </S.FieldRow>
  )
}
